<template>
  <div class="shipper_allbox">
    <div class="mode_box">
      <div class="card_info">托运人信息</div>
      <el-form
        ref="form"
        class="form_all_box"
        :model="form"
        label-width="160px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="form.staffType == 1 ? '联系人' : '托运人姓名'"
              prop="userName"
              :disabled="true"
            >
              <el-input
                v-model="form.userName"
                placeholder="请输入托运人姓名"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人手机号" prop="phone" :disabled="true">
              <el-input
                v-model="form.phone"
                autocomplete="off"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="联系人身份证号"
              prop="contactsIdnum"
              :disabled="true"
              style="position: relative"
            >
              <el-input
                v-model="form.contactsIdnum"
                autocomplete="off"
                placeholder="请输入联系人身份证号"
                clearable
                :disabled="true"
              />
              <img
                v-if="showContact"
                :src="require('@/assets/icon/pswhidden.png')"
                alt=""
                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); width: 20px; height: 20px; cursor: pointer;"
                @click="toggleContact"
              />
              <img
                v-if="!showContact"
                :src="require('@/assets/icon/pswshow.png')"
                alt=""
                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); width: 20px; height: 20px; cursor: pointer;"
                @click="toggleContact"
              />
            </el-form-item>
          </el-col>
          <!-- <el-col :span="12">
            <el-form-item label="平台服务经理手机号码" prop="salesmanPhone">
              <el-input
                v-model="form.salesmanPhone"
                autocomplete="off"
                placeholder="请输入平台服务经理手机号码"
                clearable
              />
            </el-form-item>
          </el-col> -->
          <el-col :span="9">
            <el-form-item
              label="联系人身份证有效期"
              prop="contactsIdnumValidity"
              :disabled="true"
            >
              <el-date-picker
                v-model="form.contactsIdnumValidity"
                :class="form.hasDueDateContacts ? 'disabledhide' : ''"
                type="date"
                placeholder="身份证有效期"
                value-format="yyyy-MM-dd"
                clearable
                :disabled="true"
              />
              <!-- <el-input
                v-model="form.phone"
                autocomplete="off"
                placeholder="请选择身份证有效期"
                clearable
              /> -->
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="长期" label-width="60px" :disabled="true">
              <el-checkbox
                v-model="form.hasDueDateContacts"
                disabled
                @change="
                  value => {
                    this.$set(
                      form,
                      'contactsIdnumValidity',
                      value ? '9999-12-31' : ''
                    );
                  }
                "
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="密码" prop="passwd" :disabled="true">
              <el-input
                v-model="form.passwd"
                type="password"
                autocomplete="new-password"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="form.staffType == 1" :span="12">
            <el-form-item label="公司名称" prop="companyName" :disabled="true">
              <el-input v-model="form.companyName" :disabled="true" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="住所" prop="address" :disabled="true">
              <el-input
                v-model="form.address"
                prop="address"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <!-- 主管税务机关 -->
          <el-col :span="12">
            <el-form-item
              label="主管税务机关"
              prop="myTaxOrgan"
              :disabled="true"
            >
              <el-input v-model="form.myTaxOrgan" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col v-if="form.staffType == 1" :span="12">
            <el-form-item
              label="统一社会信用代码"
              prop="businessLicenseImgNumber"
              :disabled="true"
            >
              <el-input
                v-model="form.businessLicenseImgNumber"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col v-if="form.staffType == 1" :span="12">
            <el-form-item
              label="法人代表名称"
              prop="legalName"
              :disabled="true"
            >
              <el-input v-model="form.legalName" :disabled="true" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="法人身份证号"
              prop="identificationNumber"
              :disabled="true"
              style="position: relative"
            >
              <el-input v-model="form.identificationNumber" :disabled="true" />
              <img
                v-if="showIdentification"
                :src="require('@/assets/icon/pswhidden.png')"
                alt=""
                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); width: 20px; height: 20px; cursor: pointer;"
                @click="toggleIdentification"
              />
              <img
                v-if="!showIdentification"
                :src="require('@/assets/icon/pswshow.png')"
                alt=""
                style="position: absolute; right: 10px; top: 50%; transform: translateY(-50%); width: 20px; height: 20px; cursor: pointer;"
                @click="toggleIdentification"
              />
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item
              label="法人身份证有效期"
              prop="idCardDueDate"
              :disabled="true"
            >
              <el-date-picker
                v-model="form.idCardDueDate"
                :class="form.hasDueDate ? 'disabledhide' : ''"
                type="date"
                placeholder="请选择身份证有效期"
                value-format="yyyy-MM-dd"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="长期" label-width="60px" :disabled="true">
              <el-checkbox
                v-model="form.hasDueDate"
                disabled
                @change="
                  value => {
                    this.$set(form, 'idCardDueDate', value ? '9999-12-31' : '');
                  }
                "
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <!-- <el-col :span="12">
          <el-form-item
            label="简称码"
            prop="prefix"
          >
            <el-input
              v-model="form.prefix"
            />
          </el-form-item>
        </el-col> -->
          <!-- <el-col :span="12">
          <el-form-item label="服务费率(%)" prop="taxPoint">
            <el-input v-model="form.taxPoint" type="number" />
          </el-form-item>
        </el-col> -->
          <el-col :span="12">
            <el-form-item label="通信地址" prop="areaList" :disabled="true">
              <el-cascader
                v-model="form.areaList"
                :options="parentData.areaOptions"
                :props="{
                  value: 'countyCode',
                  label: 'countyName',
                  children: 'children'
                }"
                :disabled="true"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row />

        <el-row>
          <el-col :span="24">
            <el-form-item label="上传证件" :disabled="true">
              <ImgUpload
                :upload-config="{
                  lebal: '联系人身份证人像面照片',
                  prefix: 'contactsIdentification',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="false"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '联系人身份证国徽面照片',
                  prefix: 'contactsIdentificationBack',
                  form: form,
                  suffix: 'Img'
                }"
                :parent-data="parentData"
                :required="false"
              />

              <ImgUpload
                :upload-config="{
                  lebal: '法人身份证人像面照片',
                  prefix: 'identification',
                  form: form,
                  suffix: 'Img',
                  modal: false
                }"
                :parent-data="parentData"
                :required="false"
              />
              <ImgUpload
                :upload-config="{
                  lebal: '法人身份证国徽面照片',
                  prefix: 'identificationBack',
                  form: form,
                  suffix: 'Img',
                  modal: false
                }"
                :parent-data="parentData"
                :required="false"
              />
              <!-- <ImgUpload
              :upload-config="{ lebal: '手持身份证合照', prefix: 'identificationInhand', form: form, suffix: 'Img', modal: false }"
              :parent-data="parentData"
              :required="false"
            /> -->
              <ImgUpload
                v-if="form.staffType == 1"
                :upload-config="{
                  lebal: '统一社会信用三证合一照片',
                  prefix: 'businessLicense',
                  form: form,
                  suffix: 'Img',
                  modal: false
                }"
                :parent-data="parentData"
                :required="false"
              />
              <div>
                <ImgUpload
                  :upload-config="{
                    lebal: '补充材料1',
                    prefix: 'supplementaryMaterials1',
                    form: form,
                    suffix: 'Img',
                    modal: false
                  }"
                  :parent-data="parentData"
                  :required="false"
                />
                <ImgUpload
                  :upload-config="{
                    lebal: '补充材料2',
                    prefix: 'supplementaryMaterials2',
                    form: form,
                    suffix: 'Img',
                    modal: false
                  }"
                  :parent-data="parentData"
                  :required="false"
                />
                <ImgUpload
                  :upload-config="{
                    lebal: '补充材料3',
                    prefix: 'supplementaryMaterials3',
                    form: form,
                    suffix: 'Img',
                    modal: false
                  }"
                  :parent-data="parentData"
                  :required="false"
                />
              </div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row style="line-height: 36px;">
          <el-col :span="20" :offset="2">
            <div style="padding-bottom: 22px;">
              <el-checkbox
                v-model="form.isMonthlyClient"
                label="是否为月结客户"
                :checked="!!form.isMonthlyClient"
                :false-label="0"
                :true-label="1"
                :disabled="true"
              />
              <!-- <el-checkbox
              v-if="isCtms"
              v-model="form.isIndependentCheckout"
              label="是否独立核算"
              :checked="!!form.isIndependentCheckout"
              :false-label="0"
              :true-label="1"
            /> -->
              <el-checkbox
                v-if="isCtms"
                v-model="form.isEnsure"
                label="是否需要发货保证金"
                :checked="!!form.isEnsure"
                :false-label="0"
                :true-label="1"
                :disabled="true"
              />
            </div>
          </el-col>
          <!-- <el-col v-if="form.isEnsure" :span="8">
                    <el-form-item prop="ensureFee">
                        <el-input v-model="form.ensureFee" placeholder="请输入保证金"  />
                    </el-form-item>
                </el-col> -->
        </el-row>
        <el-row v-if="form.isEnsure">
          <el-col :span="8">
            <el-form-item prop="ensureFee" label="发货保证金">
              <el-input
                v-model="form.ensureFee"
                placeholder="请输入保证金"
                :disabled="parentData.hideCheckbox"
              >
                <template slot="append">
                  元
                </template>
              </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="审核信息" prop="authMsg">
          <el-input
            v-model="authMsg"
            placeholder="请输入审核(驳回)信息"
            type="textarea"
            maxlength="100"
            show-word-limit
            :autosize="{ minRows: 4 }"
            clearable
          />
        </el-form-item>
        <!-- <el-form-item label="补充材料">
          <pdf-upload
            v-model:imgList="authMaterialList"
            :max-count="3"
            :required="false"
            @handleFileSuccess="handleMaterialSuccess"
          />
        </el-form-item> -->
      </el-form>
    </div>
    <!-- <div class="line_div"></div> -->
    <div class="mode_box">
      <div class="card_info">承运主体信息</div>
      <el-form
        ref="formData"
        class="form_all_box"
        :model="form"
        :rules="rules"
        label-width="180px"
      >
        <!-- <el-form-item label="简称码" prop="prefix">
        <el-input v-model="prefix" />
      </el-form-item> -->
        <el-row>
          <el-col :span="12">
            <el-form-item label="承运主体" prop="branchCode">
              <el-select
                v-model="form.branchCode"
                placeholder="请选择承运主体"
                :disabled="isDisableTaxPoint"
              >
                <el-option
                  v-for="item in partyGroupOptions"
                  :key="item.code"
                  :label="item.groupName"
                  :value="item.code"
                />
              </el-select> </el-form-item
          ></el-col>
          <el-col :span="12"
            ><el-form-item label="服务费率(%)" prop="taxPoint">
              <el-input
                v-model="form.taxPoint"
                type="number"
                min="0"
                :disabled="isDisableTaxPoint"
                max="100"
                placeholder="请输入服务费（%）"
              /> </el-form-item
          ></el-col>
          <!-- 平台经理     -->
          <el-col :span="12"
            ><el-form-item label="平台服务经理" prop="salesmanPhone">
              <el-select
                v-model="form.salesmanPhone"
                placeholder="请选择平台服务经理"
                :disabled="isDisableSalesmanPhone"
              >
                <el-option
                  v-for="item in salesmanArr"
                  :key="item.phone"
                  :label="item.name"
                  :value="item.phone"
                />
              </el-select> </el-form-item
          ></el-col>
        </el-row>
      </el-form>
    </div>
    <el-row class="_btns">
      <el-button type="primary" @click="funcSubmit">
        审核通过
      </el-button>
      <el-button type="danger" @click="funcRefuse">
        审核驳回
      </el-button>
    </el-row>
  </div>
</template>
<script>
import {
  getShipperInfo,
  getSecureInfo,
  shipperReview,
  salesmanList,
  updateShipperInfo
} from "@/api/shipment";
import ImgUpload from "@/components/ImgUpload";
import PdfUpload from "@/components/ImgUpload/pdfUpload.vue";
import { getRole } from "@/utils/getRole";
import request from "@/utils/request";
export default {
  name: "ShipmentEdit",
  components: {
    ImgUpload,
    PdfUpload
  },
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          areaOptions: [],
          goodsTypeList: [],
          typeOptions: [],
          vehicleDictList: [],
          bankOptions: [],
          branchList: []
        };
      }
    },
    mode: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      showContact: false,
      contactsIdnumFull: "",
      contactsIdnumMask: "",
      showIdentification: false,
      identificationNumberFull: "",
      identificationNumberMask: "",
      salesmanArr: [],
      isCtms: true, //默认显示  同城系统隐藏
      authMsg: "",
      dialogVisible: false,
      hasTaxOpen: false, //是否开启税务
      dialogImageUrl: "",
      partyGroupOptions: [],
      rules: {
        branchCode: [
          { required: true, message: "请选择承运主体", trigger: "blur" }
        ],
        salesmanPhone: [
          { required: true, message: "请选择平台服务经理", trigger: "blur" }
        ],
        taxPoint: [
          { required: true, message: "请输入服务费比例", trigger: "blur" },
          {
            type: "number",
            message: "服务费比例必须为数字",
            trigger: "blur",
            transform: value => Number(value)
          },
          {
            validator: (rule, value, callback) => {
              if (value === "" || value === undefined || value === null) {
                callback();
              } else {
                const num = Number(value);
                if (num < 0 || num > 100) {
                  callback(new Error("服务费比例必须在0-100之间"));
                } else {
                  callback();
                }
              }
            },
            trigger: "blur"
          }
        ]
      },
      form: {
        salesmanPhone: "",
        branchCode: "",
        staffType: "0", // 类型（托运人）
        userName: "",
        phone: "",
        passwd: "",
        identificationNumber: "",
        idCardDueDate: "",
        companyName: "",
        businessLicenseImgNumber: "", // 信用代码
        prefix: "",
        taxPoint: "",
        areaList: [],
        address: "",
        identificationImg: "",
        identificationBackImg: "",
        identificationInhandImg: "",
        businessLicenseImg: "",
        isIndependentCheckout: 0,
        isMonthlyClient: 0,
        isEnsure: 0,
        ensureFee: 0,
        needVerifyCompany: false,
        authMaterial: [], // 补充材料
        supplementaryMaterials1Img: "",
        supplementaryMaterials2Img: "",
        supplementaryMaterials3Img: ""
      },
      authMaterialList: [],
      code: "",
      authStatus: 0,
      prefix: "",
      isDisableTaxPoint: false,
      isDisableSalesmanPhone: false
    };
  },
  computed: {
    isCompanyMode() {
      return this.mode === "company";
    }
  },
  watch: {
    // 签约主体变化时重新按主体拉取平台经理（市场角色全量、渠道角色按主体）
    "form.branchCode"() {
      this.getSalesmanList();
    }
  },
  mounted() {
    this.getBranchList();
  },
  created() {
    let isCtmsShow = getRole(); //获取登录用户登录的是否是同城系统
    this.isCtms = !isCtmsShow;
    this.getSalesmanList();
  },
  methods: {
    handleMaterialSuccess(url) {
      console.log("补充材料上传成功:", url);
    },
    getSalesmanList() {
      salesmanList({ branchCode: this.form.branchCode }).then(res => {
        if (res.status === 0) {
          console.log("======salesmanList", res);
          this.salesmanArr = res.data;
          // this.partyGroupOptions = res.data.records;
        }
      });
    },
    // 获取主体数据
    getBranchList() {
      request({
        url: "/ntocc-basic-api/partyGroup",
        method: "get"
      }).then(res => {
        if (res.status === 0) {
          console.log(this.partyGroupOptions);
          this.partyGroupOptions = res.data.records;
        }
      });
    },
    // 获取承运商详情
    getShipperDetail(code) {
      var branchCode = code.branchCode;
      this.showContact = false;
      this.contactsIdnumFull = "";
      this.contactsIdnumMask = "";
      this.showIdentification = false;
      this.identificationNumberFull = "";
      this.identificationNumberMask = "";
      // 设置承运主体的值
      this.form.branchCode = branchCode;
      request({
        url: `/ntocc-basic-api/industry/isOpen?branchCode=` + branchCode,
        method: "get"
      }).then(response => {
        this.hasTaxOpen = response.data == "1" ? true : false;
      });
      this.code = code.code;
      getShipperInfo(this.code).then(response => {
        this.form = response.data;
        this.form.branchCode = response.data.branchCode || "";

        if (this.form.taxPoint > 0) {
          this.isDisableTaxPoint = true;
        }
        if (this.form.taxPoint == 0) {
          this.form.taxPoint = null;
        }
        if (this.form.salesmanPhone) {
          this.isDisableSalesmanPhone = true;
        }
        this.authMsg = response.data.authMsg || "";
        this.$set(
          this.form,
          "hasDueDate",
          this.form.idCardDueDate == "9999-12-31"
        );
        this.getSecureInfoApi(this.code);
      });
    },
    getSecureInfoApi(code) {
      getSecureInfo({ code: code }).then(response => {
        this.contactsIdnumFull = response.data.contactsIdnum;
        this.identificationNumberFull = response.data.identificationNumber;
        this.contactsIdnumMask = this.form.contactsIdnum;
        this.identificationNumberMask = this.form.identificationNumber;
        if (!this.showContact) {
          this.form.contactsIdnum = this.contactsIdnumFull;
        }
        if (!this.showIdentification) {
          this.form.identificationNumber = this.identificationNumberFull;
        }
      });
    },
    toggleContact() {
      this.showContact = !this.showContact;
      if (this.showContact) {
        this.form.contactsIdnum =
          this.contactsIdnumMask || this.form.contactsIdnum;
      } else {
        this.form.contactsIdnum =
          this.contactsIdnumFull || this.form.contactsIdnum;
      }
    },
    toggleIdentification() {
      this.showIdentification = !this.showIdentification;
      if (this.showIdentification) {
        this.form.identificationNumber =
          this.identificationNumberMask || this.form.identificationNumber;
      } else {
        this.form.identificationNumber =
          this.identificationNumberFull || this.form.identificationNumber;
      }
    },
    // 同意审核
    funcSubmit() {
      // if (this.prefix.trim() == "") {
      //   this.$message.warning("简称码不能为空");
      //   return;
      // }
      // 确保branchCode1有值
      if (!this.form.branchCode) {
        this.$message.warning("请选择承运主体");
        return;
      }
      if (+this.form.taxPoint === 0) {
        this.$message.warning("请填写服务费比例");
        return;
      }
      this.$refs.formData.validate(valid => {
        if (!valid) {
          return false;
        }
        const rLoading = this.openLoading();
        this.form.taxPoint = parseFloat(this.form.taxPoint);
        if (this.form.needVerifyCompany) {
          request({
            url: `/ntocc-basic-api/shipment/verifyCompany`,
            method: "get",
            params: this.form
          }).then(response => {
            const res = response.data;
            if (res.pass === 1) {
              this.funcPass(rLoading, this, 1);
            } else {
              this.$confirm(res.msg + "，是否审核通过?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
              })
                .then(() => {
                  this.funcPass(rLoading, this, 0);
                })
                .catch(() => {
                  rLoading.close();
                  return;
                });
            }
          });
        } else {
          this.funcPass(rLoading, this, 2);
        }
      });
    },
    async editUpdateShipperInfo() {
      let data = {
        ...this.form,
        salesmanPhone: this.form.salesmanPhone
      };
      let res = await updateShipperInfo(data);
      console.log("更新=======", res);
    },
    funcPass(rLoading, _this, verifyCompany) {
      _this.authStatus = 3;
      this.editUpdateShipperInfo();
      shipperReview({
        code: _this.code,
        authStatus: _this.authStatus,
        verifyCompany: verifyCompany,
        prefix: this.prefix,
        branchCode: this.form.branchCode + "",
        taxPoint: this.form.taxPoint
      }).then(response => {
        rLoading.close();
        _this.$message({
          message: response.msg,
          type: "success"
        });
        _this.$emit("fatherMethods");
      });
    },
    // 处理承运主体选择变化
    handleBranchChange(value) {
      // 清除表单验证错误
      // if (this.$refs.formData) {
      //   this.$refs.formData.clearValidate("branchCode");
      // }
    },
    // 拒绝审核
    funcRefuse() {
      if (this.authMsg.trim() == "") {
        this.$message.warning("请输入驳回原因");
        return;
      }
      // 确保branchCode1有值
      if (!this.form.branchCode) {
        this.$message.warning("请选择承运主体");
        return;
      }
      this.$refs.formData.validate(valid => {
        if (!valid) {
          return false;
        }
        const rLoading = this.openLoading();
        let _this = this;
        _this.authStatus = 2;
        shipperReview({
          code: _this.code,
          verifyCompany: 2,
          authStatus: _this.authStatus,
          authMsg: this.authMsg,
          branchCode: this.form.branchCode,
          taxPoint: this.form.taxPoint
        }).then(response => {
          rLoading.close();
          _this.$message({
            message: response.msg,
            type: "success"
          });
          _this.$emit("fatherMethods");
        });
      });
    }
  }
};
</script>
<style scoped lang="scss">
.form_all_box {
  padding-left: 20px;
  padding-right: 20px;
}
.tittle_h1 {
  font-size: 19px;
  font-weight: 600;
  margin-bottom: 15px;
}
.shipper_allbox {
  padding-right: 20px;
  padding-left: 20px;
  padding-top: 30px;
  padding-bottom: 50px;
}
.line_div {
  width: 100%;
  height: 2px;
  border-top: 2px dotted #e4e7ed;
  margin-bottom: 30px;
  margin-top: 30px;
}
.custom-grid {
  display: inline-block;
  font-size: 14px;
  color: #8c939d;
  margin-right: 20px;
}

.avatar-uploader ::v-deep.el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader-icon {
  box-sizing: border-box;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
  border-width: 1px;
  border-style: dashed;
  border-color: #c0ccda;
}

.avatar-uploader-icon:hover {
  border-color: #409eff;
}

.avatar {
  width: 148px;
  height: 148px;
  display: block;
}

.el-cascader {
  width: 100%;
}

._btns {
  display: flex;
  align-items: center;
  justify-content: center;
}
.mode_box {
  background: #ffffff;
  border-radius: 10px 10px 10px 10px;
  border: 1px solid #f0f3f8;
  overflow: auto;
  margin-bottom: 18px;

  .card_info {
    width: 100%;
    height: 62px;
    line-height: 62px;
    background: #f0f3f8;
    border-radius: 0px 0px 0px 0px;
    font-weight: bold;
    font-size: 18px;
    color: #1169e9;
    padding-left: 15px;
    margin-bottom: 43px;
  }
}
</style>
